/**
 * Shared LD-readiness state for usePermission().
 *
 * Extracted into its own zero-dependency module so the Jest setup file can
 * import and mutate it WITHOUT pulling in usePermission's full dependency graph
 * (useMyAbilityQuery, accessControlApi, …) before a test file's jest.mock()
 * calls are registered. Both this file and usePermission.ts share the same
 * module-registry instance, so mutations here are visible there at render time.
 *
 * Usage in tests:
 *   import { ldReadyState } from 'enrollment-platform/rbac/_ldReadyState'
 *   beforeEach(() => { ldReadyState.isReady = true })   // default in setup file
 *   beforeEach(() => { ldReadyState.isReady = false })  // opt-in to loading path
 */
export const ldReadyState = {
  /**
   * True once the LD React SDK client has fired `ready`. Set to true by the
   * global jest.setup-after-env beforeEach so synchronous tests work without
   * needing to mock useLDClient or wait for an async Promise cycle.
   */
  isReady: false,
}
